import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandler } from '../../helper/error_handler';
import { isErrorWithMessage } from '../../helper';
import { resettingTeamLoader } from '../slices/team';
import { RootState } from '../store';
import TeamApi from '../../apis/team';
import { EditMemberParams, SendInviteParams } from '../../params/redux/team';

export const fetchTeamThunk = createAsyncThunk(
    'team/fetch',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await TeamApi.fetchTeams(state.app.token);
            if (response?.success === 1) {
                return response?.teamMembers;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingTeamLoader());
        }
    }
);

export const sendInviteThunk = createAsyncThunk(
    'team/invite',
    async (data: SendInviteParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await TeamApi.sendInvite(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(fetchTeamThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingTeamLoader());
        }
    }
);

export const editMemberThunk = createAsyncThunk(
    'team/edit',
    async (data: EditMemberParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await TeamApi.editMember(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(fetchTeamThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingTeamLoader());
        }
    }
);

export const deleteMemberThunk = createAsyncThunk(
    'team/delete',
    async (id: number, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await TeamApi.deleteMember(state.app.token, id);
            if (response?.success === 1) {
                await dispatch(fetchTeamThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingTeamLoader());
        }
    }
);